import React, { useState } from 'react'
import {
    Link, useLocation
} from 'react-router-dom';
import { Nav } from 'react-bootstrap';

export default function Navbar() {
    const [navState, setNavState] = useState({ navState: 'closed' });

    const toggleNav = () => {
        setNavState({ navState: navState.navState === 'closed' ? 'opened' : 'closed' });
    }

    const location = useLocation();

    return (
        <div>
            <Nav className="navbar navbar-expand-md" id="mainNav">
                <div className="nav-container d-flex">
                    {
                        location.pathname === '/home' ? <div className="navbar-brand">Emmanuel<span>Joshua</span></div> : <div className="navbar-brand">My Projects<span className='sub-head-dot'>.</span></div>
                    }
                    <button className=" navbar-toggle" type="button">
                        <div id="nav-icon1" className={navState.navState} data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive"
                            aria-expanded="false" aria-label="Toggle navigation" onClick={toggleNav}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav ml-auto">
                            <Link to='/home'>
                                <li className="nav-item">
                                    <button className="nav-link d-flex link-active" >Home</button>
                                </li>
                            </Link>

                            <Link to='/portfolio'>
                                <li className="nav-item ">
                                    <button className="nav-link d-flex">Portfolio</button>
                                </li>
                            </Link>

                            {/* <Link to='/about'>
                                <li className="nav-item">
                                    <button className="nav-link d-flex" >About me</button>
                                </li>
                            </Link>

                            <Link to='/contact'>
                                <li className="nav-item">
                                    <button className="nav-link d-flex" >Contact</button>
                                </li>
                            </Link> */}

                        </ul>
                    </div>
                </div>
            </Nav>

            <Nav>
                <div className='mobile-nav '>
                    <div className="mobile-nav-content">
                        <ul className="mobile-nav-list">
                            <li className="mobile-nav-item">Home</li>
                            <li className="mobile-nav-item">About</li>
                            <li className="mobile-nav-item">Projects</li>
                            <li className="mobile-nav-item">Contact</li>
                        </ul>
                    </div>
                </div>
            </Nav>
        </div>
    )
}
